import { QUERY_SQL_PREVIEW_LINES } from 'src/components/star-grid/queryStatsConstants';

export interface QuerySqlPreview {
  readonly text: string;
  readonly truncatable: boolean;
}

export const querySqlPreview = (sql: string, expanded: boolean, limit: number = QUERY_SQL_PREVIEW_LINES): QuerySqlPreview => {
  const lines = sql.split('\n');
  const truncatable = lines.length > limit;
  return { text: expanded || !truncatable ? sql : lines.slice(0, limit).join('\n'), truncatable };
};
